/**
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2021 Pearson Education, Inc. All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 * patent applications, and are protected by trade secret or copyright law.
 * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 * is strictly forbidden unless prior written permission is obtained
 * from Pearson Education, Inc.
 */

/**
 * Translation file for German language
 *
 * @file de.js
 * @author Manimaran.S
 */
const de = {
  'popularChannelSlider.allChannels': 'Alle Channels',
  'popularChannelSlider.recommended': 'Empfohlen',
  'hero.myetextbook.link': 'zu',
  'hero.myetextbook.text': 'Nicht der richtige Titel? Greifen Sie auf Ihre eTextbuch-Bibliothek',
  'hero.etextfeaturestitle': 'Lernmaterialien in Ihrem eTextbuch finden',
  'hero.etextfeaturesdescription': 'Ihr eTextbuch enthält Lehrmaterialien, die Ihnen zum Erfolg verhelfen sollen. Nutzen Sie Flashcards und vieles mehr direkt in Ihrem eTextbuch.',
  'aichat.title1': 'KI-gestützte Hilfe zu allem, was mit diesem eTextbuch zu tun hat.',
  'aichat.chatDesc1': 'Geben Sie eine Frage ein, um zu beginnen',
  'subscriptiontext.isSubscribed': 'Teil Ihres Abonnements',
  'subscriptiontext.nonSubscriber': 'Upgrade für vollen Zugriff',
  'topicConatiner.otherHeader': 'Zugehörige Videos und Übungen',
  'topicConatiner.exactLiteHeader': 'Zugehörige Konzepte und Übungen',
  'moremenu.downloadApp': 'App herunterladen',
  'moremenu.downloadAppAlreadyDownload': '%Click here% zum Herunterladen der App auf ein anderes Gerät und zur automatischen Anmeldung oder zur sicheren Anmeldung in der bereits installierten App mit Ihrem individuellen QR-Code.',
  'moremenu.downloadAppNotDownload': '%Click here% um die App herunterzuladen und sich mit Ihrem eindeutigen QR-Code sicher anzumelden.',
  'channel.noBundletitle': 'Verwenden Sie die Lernvorbereitung für Ihre zugehörigen und sonstigen Kurse',
  'onboard.studyPlan': 'Persönlicher Studienplan erstellt!',
  'onboard.addCourseAnother': 'Möchten Sie einen weiteren Kurs hinzufügen?',
  'onboard.purchase': 'Ich muss ein eTextbook von Pearson kaufen',
  'onboard.addCourseWithoutEtext': 'Kurs mit Lernvorbereitung hinzufügen',
  'onboard.mayBeLater': 'Vielleicht später',
  'onboard.aboutCourse': 'Erzählen Sie uns von Ihrem Kurs',
  'onboard.close': 'Schließen',
  'course.addTitle': 'Kurs hinzufügen',
  'common.PURCHASE': 'Kaufen',
  'common.CLOSE': 'Schließen',
  'open': 'öffnen',
  'continue': 'Weiter',
  'yes': 'Ja',
  'no': 'Nein',
  'audio': 'Audio',
  'courses.toc.PUBLISH_SUCCESS': 'Erfolg!',
  'courses.toc.PUBLISH_MESSAGE': 'Die Studenten sehen Ihre Änderungen beim nächsten Öffnen von Inhalten.',
  'errors.GENERIC_TITLE': 'Sie haben derzeit keinen Zugriff',
  'errors.GENERIC_DESC': 'Aktualisieren Sie zunächst die Seite oder leeren Sie den Browser-Cache. Falls das Problem weiterhin besteht, wenden Sie sich an den ',
  'errors.GENERIC_LINK': 'Support von Pearson.',
  'errors.GENERIC_CODE': 'Fehlercode: {code}',
  'errors.SUBSCRIPTION_GENERIC_TITLE': 'Abonnement konnte nicht gefunden werden',
  'errors.SUBSCRIPTION_GENERIC_DESC': 'Ihr Konto enthält keinen Zugriff auf diesen Titel. Wenn Sie der Meinung sind, dass Sie diese Nachricht irrtümlich erhalten haben, wenden Sie sich bitte an den technischen Support von Pearson',
  'errors.SUBSCRIPTION_REGISTRATION_TITLE': 'Abonnement konnte nicht gefunden werden',
  'errors.SUBSCRIPTION_REGISTRATION_DESC': 'Ihr Abonnement beinhaltet keinen Zugriff auf den eText. Sie können ihn jedoch jetzt mit einer Kreditkarte abonnieren.',
  'link.ACCESSIBILITY': 'https://www.pearson.com/us/accessibility.html',
  'link.PRIVACY': 'https://pi.pearsoned.com/v1/piapi/login/static/html/PearsonPrivacyPolicy.html',
  'link.SUPPORT': 'https://support.pearson.com/getsupport/s/?_ga=2.116082310.1845539610.1557867919-NimtqV7BcT00BM9xOXCQUFJYwF3RzEIk',
  'link.TOSURL': 'https://pi.pearsoned.com/v1/piapi/login/static/html/PearsonEULA.html',
  'link.FAQS_NONMOJO': '',
  'link.TERMS_OF_USE_NONMOJO': 'https://www.pearson.com/en-us/legal-information/terms-of-use.html',
  'link.PRIVACY_NOTICE_NONMOJO': 'https://www.pearson.com/en-us/legal-information/privacy-policy.html',
  'link.ACCESSIBILITY_SUPPORT_NONMOJO': '',
  'menu.myAccount': 'Mein Konto',
  'menu.helpCenter': 'Hilfe-Center',
  'menu.preferencesCenter': 'Einstellungen-Center',
  'menu.CONTACT_SUPPORT': 'Support kontaktieren',
  'menu.HELP_SUPPORT': 'Hilfe und Unterstützung',
  'menu.FAQS': 'Häufig gestellte Fragen (FAQs)',
  'menu.CHAT_WITH_SUPPORT': 'Chat mit dem Support',
  'menu.OTP_CODES': 'OTP-Codes',
  'menu.LAUNCH_CODE': 'Code-Protokoll starten',
  'menu.SEND_CODE': 'Benutzer neuen Code per E-Mail senden',
  'menu.SEND_CODE_PHONE': 'Benutzer neuen Code per Textnachricht senden',
  'menu.LEGAL': 'Rechtliches',
  'menu.PRIVACY_NOTICE': 'Datenschutzerklärung',
  'menu.TITLE_INFO': 'Titel-Informationen',
  'menu.PEARSON_ACCESSIBILITY': 'Barrierefreiheit von Pearson',
  'menu.DEVICE_WARNING_MESSAGE': 'Registrieren Sie {deviceLimit} Geräte. Tauschen Sie 1 pro Monat aus.',
  'menu.ACCESSIBILITY': 'Zugänglichkeit',
  'menu.ACCESSIBILITY_SUPPORT': 'Unterstützung der Barrierefreiheit',
  'menu.DEVICES': 'Neueste Geräte',
  'menu.THIS_DEVICE': 'Dieses Gerät',
  'menu.GET_THE_APP_DOWNLOAD': 'Mobile App herunterladen',
  'menu.MOJO_APP_INFO': 'Rufen Sie den App-Store auf Ihrem Telefon oder Tablet auf, um Pearson+ offline zu nutzen.',
  'menu.DEVICE_LABEL': 'Gerät',
  'menu.DEVICE_DISCONNECT': 'Verbindung trennen',
  'menu.FOXIT': 'Unterstützt von Foxit',
  'menu.TERMS_OF_USE': 'Nutzungsbedingungen',
  'menu.SIGN_OUT': 'Abmelden',
  'menu.PRINT_PAGE': 'Seite drucken',
  'menu.COPY_RIGHT': 'Copyright © {year} Pearson Education Inc. Alle Rechte vorbehalten.',
  'print.FOOTER_MESSAGE': 'Gedruckt von {fullName}({email}) am {currentDate}.',
  'print.WATERMARK': 'Copyright © {year} Pearson Education',
  'device.SWAPPED_ALREADY': 'Sie haben diesen Monat bereits getauscht',
  'device.SWITCH_DEVICE': 'Zum aktuellen Gerät wechseln?',
  'device.SWITCH_ONCE': 'Da Sie nur einmal im Monat wechseln können, können Sie dies nicht mehr rückgängig machen.',
  'device.SEAT_TAKEN': 'Dieser Platz ist besetzt',
  'device.DISCONNECT_DEVICE': 'Sie können sich nur an 3 Geräten anmelden. Um hier fortzufahren, trennen Sie die Verbindung zu einem weiteren Gerät.',
  'device.ALERT_TEXT': 'Denken Sie daran, dass Sie die Geräte nur einmal im Monat tauschen können.',
  'device.DISCONNECT': 'Verbindung trennen',
  'device.CONTINUE': 'Weiter',
  'device.HEADER': 'Ihre andere Browser-Sitzung beenden?',
  'device.CLOSE': 'Zurück zur Startseite',
  'device.CODE': 'Fahren Sie hier fort, indem Sie den Authentifizierungscode eingeben, den wir an {maskedEmail} gesendet haben. Funktioniert nicht? Prüfen Sie Ihren Spam-Ordner, {email}, oder kontaktieren Sie {support}.',
  'device.TIMER': 'Sie haben {time}, um Ihren Code hier einzugeben',
  'device.RESEND': '{resend}',
  'device.FAQ': 'Häufig gestellte Fragen',
  'device.RESEND_NAME': 'Erneut senden',
  'device.NOTE': 'Wenn Sie Pearson+ regelmäßig an zwei Orten nutzen, z. B. bei der Arbeit und zu Hause, melden Sie sich nach jeder Nutzung ab. Sie können die Pearson+ Mobile-App außerdem auf bis zu zwei Geräten verwenden. Weitere Informationen finden Sie in unseren {faq}.',
  'device.NOTE_HEADER': 'Vermeiden Sie dies nächstes Mal',
  'device.CONTACT_SUPPORT': 'Kundendienst',
  'device.CONTACT_EMAIL': 'aktualisieren Sie Ihre E-Mail',
  'device.INCORRECT': 'Falscher Code - überprüfen Sie Ihren Code noch einmal oder senden Sie ihn erneut.',
  'device.MANY_ATTEMPTS': 'Zu viele Versuche, versuchen Sie, den Code erneut zu senden',
  'device.EXPIRED': 'Ihre Zeit ist abgelaufen. Versuchen Sie, den Code erneut zu senden',
  'device.ACCESS_HEADER': 'Sie haben es geschafft!',
  'device.ACCESS_DESC': 'Ihre Sitzung wurde authentifiziert. Möchten Sie gleich noch Ihr Passwort aktualisieren?',
  'device.ACCESS_CHANGE_PASSWORD': 'Passwort ändern',
  'device.ACCESS_RESET_PASSWORD': 'Passwort zurücksetzen',
  'device.THREATONE_TITLE': 'Sie alles gut aus?',
  'device.THREATONE_DESC': 'Wir haben eine verdächtige Aktivität auf Ihrem Konto festgestellt.',
  'device.THREATONE_DESC_TWO': 'Dies wäre ein guter Zeitpunkt, um Ihr Passwort zu ändern.',
  'device.MAY_BE_LATER': 'Vielleicht später',
  'device.OKAY': 'OK',
  'device.ACCOUNT_LOCK_DESC': 'Aus Sicherheitsgründen melden wir Sie jetzt ab. Wir haben einen Link zum Zurücksetzen des Passworts an die mit Ihrem Konto verknüpfte E-Mail geschickt.',
  'device.ACCOUNT_LOCK_TITLE': 'Wir haben eine verdächtige Aktivität auf Ihrem Konto festgestellt',
  'device.ACCOUNT_LOCK_TIMER': 'Sie werden abgemeldet in {time}',
  'navigation.PAGE': 'Seite',
  'launchcode.CREATEBY': 'Erstellt von:',
  'launchcode.sentvia': 'Gesendet per:',
  'launchcode.CODEINLAST': 'Codes in den letzten 7 Tagen:',
  'launchcode.TIMESENT': 'Uhrzeit gesendet:',
  'launchcode.ACCOUNTEMAIL': 'E-Mail-Konto:',
  'launchcode.LAUNCHDIALOGTITLE': 'OTP-Code-Protokoll',
  'textmessage.TITLE': 'Telefonnummer eingeben',
  'textmessage.PHONE_NUMBER': 'Telefonnummer',
  'textmessage.SEND_CODE': 'Code senden',
  'textmessage.INVALID_NUMBER': 'Ungültige Telefonnummer.',
  'textmessage.SUCCESS_MESSAGE': 'Code gesendet',
  'remove.title': 'Soll der Titel entfernt werden?',
  'remove.subTitle': 'Sie können ihn später jederzeit wieder hinzufügen - verwenden Sie einfach die Suche, um ihn erneut hinzuzufügen.',
  'remove.buttonText': 'Entfernen',
  'search.searchPlaceHolderPPlus': 'Suche nach ISBN, Titel oder Autor',
  'search.searchPlaceHolderEText': 'Suchen Sie in Ihrer Bibliothek',
  'footer.downloadMobileApp': 'Mobile App herunterladen',
  'footer.termsOfUse': 'Nutzungsbedingungen',
  'footer.privacy': 'Datenschutz',
  'footer.cookies': 'Cookies',
  'footer.doNotSellMyPersonalInformation': 'Verkaufen Sie meine personenbezogenen Informationen nicht',
  'footer.accessibility': 'Zugänglichkeit',
  'footer.patentNotice': 'Hinweis zum Patent',
  'footer.copyrights': 'Pearson Alle Rechte vorbehalten.',
  'hero.toc.defaultPlacehoder': '--- ein Thema auswählen ---',
  'hero.openEtextBookV1': 'eTextbuch öffnen',
  'hero.heroHeading': 'Da Sie Folgendes studieren: <span>{channel_title}</span>',
  'hero.heroHeadingForBundleUser': 'Lernvorbereitung',
  'hero.study.help': 'Lernhilfe erhalten',
  'hero.study.jumpBackIn': 'Zurückspringen',
  'hero.study.numOfUsers': 'Zurzeit nutzen <b>{num_of_users}</b> Studenten Channels.',
  'hero.heroChannel.cardsHeading': 'Machen Sie dort weiter, wo Sie aufgehört haben',
  'hero.marketingcard1.copy.title': 'Lernen Sie mit Videos',
  'hero.marketingcard1.copy.description': 'Sehen Sie sich kurz gefasste Erklärungsvideos an, die schwierige Themen aufschlüsseln.',
  'hero.marketingcard2.copy.title': 'Üben Sie Aufgaben',
  'hero.marketingcard2.copy.description': 'Bereiten Sie sich mit Tausenden von prüfungsähnlichen Fragen und Videolösungen auf Ihre Prüfung vor',
  'hero.marketingcard3.copy.title': 'Holen Sie sich Hilfe bei erfahrenen Tutoren',
  'hero.marketingcard3.copy.description': 'Stellen Sie Fragen und erhalten Sie Antworten von Fachleuten.',
  'hero.popularTopics.heading': 'Andere beliebte Themen in diesem Channel',
  'hero.popularChannels.headingv1': 'Nehmen Sie an einem anderen Kurs teil?',
  'hero.popularChannels.descriptionv2': 'Durchsuchen Sie beliebte Themen der Studienhilfe.',
  'hero.practice': 'Üben',
  'hero.herobook.mappedChannelHeading': 'Empfohlene Studienhilfe in diesem Channel',
  'libraryL2.myBooks': 'Meine Bücher',
  'libraryL2.archived': 'Archiviert',
  'libraryL2.back': 'Zurück',
  'hero.practiceProblem': 'Übungsaufgabe',
  'nativeAppBanner.drawer.title': 'In ... öffnen',
  'nativeAppBanner.drawer.pearsonApp': 'Pearson+ App',
  'nativeAppBanner.banner.title': 'Pearson+ App',
  'nativeAppBanner.banner.description': 'Lernen, währen Sie unterwegs sind',
  'hero.promotionalcard.list1': 'Sehen Sie sich kurz gefasste Videos an, die schwierige Themen aufschlüsseln',
  'hero.promotionalcard.list2': 'Tausende von prüfungsähnlichen Fragen',
  'hero.promotionalcard.list3': 'Erhalten Sie Antworten von Fachleuten',
  'hero.studyandexamprep': 'Lernvorbereitung',
  'hero.heroBook.sectionSubHeadingV1': 'Meistern Sie schwierige Themen mit mit Videoerläuterungen und Übungsfragen, die auf Ihren Kurs zugeschnitten sind.',
  'hero.heroBook.sectionSubHeadingV2': 'Meistern Sie schwierige Themen mit mit Konzepterläuterungen und Übungsfragen, die auf Ihren Kurs zugeschnitten sind.',
  'hero.SeeAllStudyOptions': 'Alle Lernoptionen anzeigen',
  'hero.herobook.mappedChannelHeadingV1': 'Empfohlene Videos und Übungsfragen',
  'hero.popularTopics.headingV1': 'Andere beliebte Themen',
  'hero.heroHeadingV1': 'Für <span>{replace_value}</span>',
  'hero.learnmore': 'Mehr erfahren',
  'hero.eTextbook': 'eTextbuch',
  'hero.goToPage.label': 'Weiter zur Seite',
  'subscription.studyTitle': 'Lernvorbereitung',
  'print.printAvailTitle': 'Sie möchten diese Seite drucken? So geht es:',
  'print.printAvailDesc': 'Wählen Sie in Ihrem eTexbuch das Kontosymbol rechts oben aus. Wählen Sie aus den Optionen „Seite drucken“ und dann Ihre Druckeinstellungen aus.',
  'print.printNotAvailTitle': 'Die Druckfunktion ist für dieses eText nicht verfügbar.',
  'print.printNotAvailDesc': 'Für einen bequemen Offline-Zugriff laden Sie Ihren Titel bitte über die Pearson+ Mobile-App herunter. So können Sie jederzeit und überall flexibel lernen!',
  'hero.header.cta': 'Zu Lernwerkzeugen gehen',
  'hero.header.ctav2': 'Lernvorbereitung öffnen',
  'hero.marketing.title': 'Finden Sie Ihr eTextbuch',
  'hero.marketing.subTitle': 'Wählen Sie aus über 2.000 eTextbüchern mit Audio, Flashcards, Notizen, Expertenvideos und mehr. Nur 10,99 $/Monat für eine Laufzeit von 4 Monaten.',
  'hero.popularchannels.desc': 'Erhalten Sie Lernhilfe mit diesen Top-Fächern',
  'hero.removecourse.title': 'Kurs vom Dashboard entfernen?',
  'hero.removecourse.description': 'Sie können diesen Kurs Ihrem Dashboard jederzeit wieder hinzufügen, indem Sie auf „Kurs hinzufügen“ klicken.',
  'hero.removecourse.primaryCtaText': 'Entfernen',
  'hero.removecourse.secondaryCtaText': 'ABBRECHEN',
  'hero.tableOfContents': 'Inhaltsverzeichnis',
  'hero.search': 'Suche',
  'hero.emptystate.cta': 'eTextbooks durchsuchen',
  'hero.watch_it_again': 'Erneut ansehen',
  'hero.mondly.learnLang.title': 'Lernen Sie kostenlos eine neue Sprache',
  'hero.mondly.subTitle': 'Nutzer des eTextbuchs von Pearson erhalten drei Monate lang kostenlos Mondly von Pearson.',
  'hero.mondly.description': 'Mit den meisten Apps zum Sprachen lernen können Sie nur auf Englisch lernen. Aber am besten ist es, wenn Sie in Ihrer Muttersprache lernen. Deshalb können Sie mit Mondly in jeder unserer 41 Sprachen lernen.',
  'hero.mondly.startLearningCTA': 'Mit dem Lernen beginnen',
  'hero.mondly.marketing.bestApp': 'Beste App',
  'hero.mondly.marketing.appStore': 'App Store',
  'hero.mondly.marketing.appYear': 'App des Jahres',
  'hero.mondly.marketing.fbStart': 'Facebook FbStart - 2017 EMEA-Gewinner',
  'hero.mondly.marketing.editorChoice': 'Empfehlung der Redaktion',
  'hero.mondly.marketing.googlePlay': 'Google Play',
  'header.menu.learnLanguage': 'Lernen Sie eine Sprache',
  'header.menu.moreAtPearson': 'Mehr bei Pearson',
  'hero.subscriptionStatusTitle2': 'Ihre Ressourcen bei Pearson+',
  'hero.startStudying': 'Mit dem Lernen beginnen',
  'onboard.studyMaterials': 'Wählen Sie Ihr Thema und wir erstellen ein Dashboard mit maßgeschneiderten Lernmaterialien.',
  'hero.myETextbooks': 'Meine eTextbücher',
  'header.continueInTheApp': 'Weiter in der App',
  'hero.learnTxt': 'Lernen',
  'hero.examPrepTxt': 'Prüfungsvorbereitung',
  'hero.aITutorTxt': 'KI-Tutor',
  'AI.toolTip': 'Stellen Sie Fragen zu allem in Ihrem eTextbuch',
  'hero.studyExamPrepAllYourCourses': 'Lernvorbereitung für alle Ihre Kurse',
  'header.qrCode.subHeaderTxt': 'Verwenden Sie diesen QR-Code, um sich schnell und sicher auf Ihrem Mobilgerät bei der Pearson+-App anzumelden.',
  'header.qrCode.dontHaveApp': 'Sie haben die App nicht?',
  'header.qrCode.footerTxt': 'Durch das Scannen dieses Codes werden Sie zum App Store oder zu Google Play weitergeleitet. Nachdem Sie die App heruntergeladen haben, melden Sie sich durch erneutes Scannen an.',
  'header.qrCode.errorMsg': 'Der QR-Code konnte nicht geladen werden. Schließen und erneut versuchen.',
  'hero.yourETextbook': 'Ihr eTextbuch',
  'onboard.addCourseWithEtextBundle': 'Kurs mit Lernvorbereitung hinzufügen',
  'onboard.disableTooltipText': 'Alle Lernvorbereiungskurse wurden hinzugefügt!',
  'subscriptionstatus.bundlecta': 'Zugriff auf die Lernvorbereitung',
  'subscriptionstatus.nonbundlecta': 'Zugriff auf die Lernvorbereitung',
  'channel.genericBundle': 'Nutzen Sie Ihre Lernvorbereitung zur Hilfe bei anderen Kursen',
  'channel.relatedBundle': 'Nutzen Sie Ihre Lernvorbereitung auch zur Hilfe bei anderen Kursen',
  'onboard.courseAdded': 'Kurs hinzugefügt!',
  'hero.flashcards': 'Karteikarten',
  'relatedChannelCard.title': 'Mit dieser ergänzenden Ressource können Sie Ihren Lernprozess verbessern',
  'relatedChannelCard.badgeText': 'Verwandte Lernvorbereitung',
  'sessionInactivity.title': 'Sind Sie noch da?',
  'sessionInactivity.description': 'Ihre Sitzung wird in <b>%TIMER%</b> wegen längerer Inaktivität beendet.<br/>Möchten Sie angemeldet bleiben?',
  'sessionInactivity.keepMeSignIn': 'Angemeldet bleiben',
  'sessionInactivity.signOut': 'Abmelden',
  'sessionTimeout.title': 'Sitzung abgelaufen',
  'sessionTimeout.description': 'Ihre Sitzung ist wegen längerer Inaktivität abgelaufen.',
  'print.qrCode.header': 'Verwenden Sie diesen QR-Code, um die Pearson+-App auf Ihrem Mobilgerät zu öffnen.',
  'print.qrCode.footer': 'Durch das Scannen dieses Codes werden Sie zum App Store oder zu Google Play weitergeleitet. Nachdem Sie die App installiert haben, melden Sie sich an, um Ihren Titel herunterzuladen und auf ihn zuzugreifen.',
  'hero.nestest.title': 'Vorbereitung auf Ihre Lehramts-Zertifizierungsprüfungen',
  'hero.nestest.subTitle': 'Nutzer von Pearson+ können jetzt auf bundesweit abgestimmte Vorbereitungskurse und Übungstests zugreifen, um sich auf ihre Lehramts-Zertifizierungsprüfungen vorzubereiten.',
  'hero.channelAI.title': 'Benötigen Sie Hilfe? Der KI-Tutor ist für Sie da.',
  'hero.channelAI.desc': 'Bei Fragen liefert er Schritt-für-Schritt-Hausaufgabenhilfe, Lernempfehlungen und vieles mehr – individuelle Hilfe, wann immer man sie braucht.',
  'hero.channelAI.action': 'Jetzt den KI-Tutor fragen',
  'new': 'Neu!',
  'hero.practice.numOfUsers': 'Dieser Abschnitt hat <b>{practice_num_of_users}</b> Übungsaufgaben.',
  'hero.practice.cta': 'Üben Sie jetzt',
  'hero.practice.title': 'Übungsaufgabe',
  'diagnostics.errorMsg': 'Die Diagnose wurde nicht geladen. Bitte schließen Sie das Fenster und versuchen Sie es erneut.',
  'qrcode.title': 'Überall mit dem Lernen beginnen',
  'qrcode.subtitle': 'Lernen Sie überall und jederzeit mit der Pearson+ Mobile-App. Laden Sie sie jetzt herunter und profitieren Sie von einem nahtlosen Lernerlebnis.',
  'qrcode.detailsv1': 'Mit der Pearson+ App können Sie diesen QR-Code nutzen und dort weitermachen, wo Sie aufgehört haben. Durchsuchen Sie Ihr Buch, lernen Sie mit Lernkarten, sehen Sie sich Videolektionen an und vieles mehr – ganz egal, wo Sie gerade sind.',
  'qrcode.detailsv2': 'Scannen Sie diesen QR-Code, wann immer Sie sich schnell anmelden möchten, und machen Sie genau dort weiter, wo Sie aufgehört haben.',
  'qrcode.details': 'Mit der Pearson+ App können Sie diesen QR-Code nutzen und dort weitermachen, wo Sie aufgehört haben.',
  'qrcode.appstore': 'App Store',
  'qrcode.playstore': 'Google Play',
  'nativePromoBanner.description': 'Lernen Sie überall und jederzeit mit der Pearson+ Mobile-App. Laden Sie sie jetzt herunter und profitieren Sie von einem nahtlosen Lernerlebnis.',
  'install': 'Install',
  'header.menu.createCourse': 'Neuer Kurs',
  'header.dropdown.courses': 'Kurse',
  'header.dropdown.recentlyViewed': 'Kürzlich angezeigt',
  'header.dropdown.viewAll': 'Alle Kurse anzeigen',
  'aet.courseHeader.inviteStudents': 'Studierende einladen',
  'aet.courseHeader.inviteStudentModal.subTitle': 'Laden Sie Studierende ein, auf dieses eTextbook zuzugreifen, indem Sie die unten stehende Linkadresse oder die Anweisungen in Ihre E-Mail oder Ihren Lehrplan kopieren.',
  'aet.courseHeader.inviteStudentModal.linkAddress': 'Link-Adresse',
  'aet.courseHeader.inviteStudentModal.copyLink': 'Link kopieren',
  'aet.courseHeader.inviteStudentModal.instructionsTitle': 'Anweisungen mit Link-Adress',
  'aet.courseHeader.inviteStudentModal.copyInstructions': 'Anweisungen kopieren',
  'aet.courseHeader.inviteStudentModal.instructionIntro': 'Es ist an der Zeit auf {bookTitle} das eTextbook für {courseName} zuzugreifen.\n\n',
  'aet.courseHeader.inviteStudentModal.instructionAccessLink': 'Wenn Sie bereit sind, greifen Sie auf Ihr eTextbuch zu auf: {enrollmentLink}\n\n',
  'aet.courseHeader.inviteStudentModal.instructionSignIn': 'Sie werden aufgefordert, sich mit Ihrem bestehenden Pearson-Konto anzumelden. Falls Sie kein Pearson-Konto haben, können Sie eines erstellen.\n\n',
  'aet.courseHeader.inviteStudentModal.instructionHelp': 'Benötigen Sie Hilfe?',
  'aet.courseHeader.inviteStudentModal.instructionHelpLink': 'AskPearson',
  'aet.courseHeader.startDate': 'Startdatum:',
  'aet.courseHeader.endDate': 'Enddatum:',
  'aet.courseHeader.start': 'Start:',
  'aet.courseHeader.end': 'End:',
  'aet.courseHeader.moreOptions': 'More options',
  'aet.courseHeader.entitlement': 'Entitlement:',
  'aet.courseHeader.format': 'Format:',
  'aet.home.manageroster': 'Teilnehmerliste verwalten',
  'aet.home.managegradesync': 'Notensynchronisierung verwalten',
  'aet.home.copycourse': 'Kurs kopieren',
  'aet.home.unlinkcourse': 'Unlink course',
  'aet.tempAccess.warningBannerMessage': 'Temporary access expires on {date}',
  'aet.tempAccess.upgradeAccessLabel': 'Upgrade access',
  'aet.tempAccess.expiredTitle': 'Temporary access has expired',
  'aet.tempAccess.expiredWithActionDescription': 'Your progress has been saved. Upgrade your access now to continue where you left off.',

  'aet.instructorCourse.tabs.current': 'Aktuell',
  'aet.instructorCourse.tabs.past': 'Vergangen',
  'aet.instructorCourse.tabs.courseSettings': 'Kurseinstellungen',
  'aet.instructorCourse.tabs.assignmentSettings': 'Assignment settings',
  'aet.instructorCourse.assignmentSettings.lmsAlertMessage': 'Important: Your LMS may also have assignment scoring settings. Changes in both places are applied together. To avoid unintended changes to final scoring, update settings in one place.',
  'aet.instructorCourse.assignmentSettings.gradebookSectionTitle': 'Display assignment scores in gradebook as',
  'aet.instructorCourse.assignmentSettings.gradebookInfoButtonAriaLabel': 'Learn about raw score and equal weighting',
  'aet.instructorCourse.assignmentSettings.rawScoreTitle': 'Raw score',
  'aet.instructorCourse.assignmentSettings.rawScoreDescription': 'Assignment scores vary based on the number of questions in each assignment.',
  'aet.instructorCourse.assignmentSettings.equalWeightingTitle': 'Equal weighting',
  'aet.instructorCourse.assignmentSettings.equalWeightingDescription': 'All assignments have the same base value.',
  'aet.instructorCourse.assignmentSettings.baseValueLabel': 'Base value:',
  'aet.instructorCourse.assignmentSettings.availabilitySectionTitle': 'Assignment availability',
  'aet.instructorCourse.assignmentSettings.availabilityFieldLabel': 'Assignments are available to students',
  'aet.instructorCourse.assignmentSettings.dueDatesSectionTitle': 'Scheduling defaults',
  'aet.instructorCourse.assignmentSettings.defaultDueTimeLabel': 'Default due time',
  'aet.instructorCourse.assignmentSettings.courseTimeZoneLabel': 'Course time zone',
  'aet.instructorCourse.assignmentSettings.cancelButtonLabel': 'Cancel',
  'aet.instructorCourse.assignmentSettings.saveButtonLabel': 'Save changes',
  'aet.instructorCourse.assignmentSettings.gradebookInfoModalTitle': 'Raw Score vs Equal Weighting',
  'aet.instructorCourse.assignmentSettings.gradebookInfoRawScoreHeading': 'Raw Score:',
  'aet.instructorCourse.assignmentSettings.gradebookInfoRawScoreBody': 'Grades reflect total points earned out of total points possible across all assignments. Longer or higher-point assignments naturally impact the final grade more.',
  'aet.instructorCourse.assignmentSettings.gradebookInfoEqualWeightingHeading': 'Equal Weighting:',
  'aet.instructorCourse.assignmentSettings.gradebookInfoEqualWeightingBody': 'Every assignment is normalized using a consistent base value so that each task contributes equally to the final grade, regardless of length or point total.',
  'aet.instructorCourse.assignmentSettings.baseValueRequired': 'Base value is required',
  'aet.instructorCourse.assignmentSettings.baseValueInvalid': 'Enter a value between 1 and 100',
  'aet.instructorCourse.assignmentSettings.availability.immediate': 'Immediately upon publish',
  'aet.instructorCourse.assignmentSettings.availability.fourWeeksBefore': '4 weeks before due date',
  'aet.instructorCourse.assignmentSettings.availability.twoWeeksBefore': '2 weeks before due date',
  'aet.instructorCourse.assignmentSettings.availability.oneWeekBefore': '1 week before due date',
  'aet.instructorCourse.tabs.manageRoster': 'Teilnehmerliste verwalten',
  'aet.instructorCourse.currentCourses.title': 'Aktuelle Kurse',
  'aet.instructorCourse.pastCourses.title': 'Frühere Kurse',
  'aet.instructorCourse.archivedCourses.title': 'Archived courses',
  'aet.instructorCourse.archivedCourses.description': 'Archived titles are hidden from Current and Past. Your access to each title doesn’t change — unarchive it any time to put it back on your bookshelf.',
  'aet.instructorCourse.archivedCourses.emptyStateTitle': 'No archived titles',
  'aet.instructorCourse.archivedCourses.emptyStateDescription': 'Archive a title from Current or Past using its ··· menu. It moves here without changing your access.',
  'aet.instructorCourse.archiveDialog.title': 'Archive title(s)',
  'aet.instructorCourse.archiveDialog.description': 'Archived titles will move to the Archived tab, and all courses that use that title will be archived. They can still be accessed from the archived section, directly from the MLM course, and from Console. You can unarchive it anytime from the Archived tab.',
  'aet.instructorCourse.archiveDialog.confirmCTA': 'Archive',
  'aet.instructorCourse.unarchiveDialog.title': 'Unarchive title(s)',
  'aet.instructorCourse.unarchiveDialog.description': 'Unarchived titles will be accessible from your home page.',
  'aet.instructorCourse.unarchiveDialog.confirmCTA': 'Unarchive',
  'aet.home.archiveCourse': 'Archive',
  'aet.home.unarchiveCourse': 'Unarchive',
  'aet.instructorCourse.createOrCopy.title': 'Erstellen oder kopieren Sie einen eTextbuch-Kurs von Pearson',
  'aet.instructorCourse.createOrCopy.sectionTitle': 'Kurs eines anderen Ausbilders kopieren oder einen neuen erstellen',
  'aet.instructorCourse.createOrCopy.copyPanel.title': 'Kurs eines anderen Ausbilders kopieren',
  'aet.instructorCourse.createOrCopy.copyPanel.subtitle': 'Geben Sie die Kurs-ID ein, um den Kurs zu finden, den Sie kopieren möchten.',
  'aet.instructorCourse.createOrCopy.copyPanel.courseIdLabel': 'Kurs-ID',
  'aet.instructorCourse.createOrCopy.copyPanel.courseIdPlaceholder': 'Kurs-ID eingeben',
  'aet.instructorCourse.createOrCopy.copyPanel.searchedForPrefix': 'Sie haben nach Folgendem gesucht',
  'aet.instructorCourse.createOrCopy.catalogPanel.title': 'Neuen Kurs vom Katalog erstellen',
  'aet.instructorCourse.createOrCopy.catalogPanel.subtitle': 'Suche nach Titel, Autor, ISBN oder fachbezogenem Stichwort',
  'aet.instructorCourse.createOrCopy.catalogPanel.searchPlaceholder': 'Suche...',
  'aet.instructorCourse.createOrCopy.showMoreLabel': 'Mehr anzeigen',
  'aet.instructorCourse.createOrCopy.showLessLabel': 'Weniger anzeigen',
  'aet.instructorCourse.cancel': 'ABBRECHEN',
  'aet.instructorCourse.loading': 'Wird geladen...',
  'aet.instructorCourse.courseForm.copyError': 'Your course cannot be copied because the title is no longer supported. Please contact your Pearson representative or customer support.',
  'aet.instructorCourse.courseForm.gradeSync': 'Notensynchronisierung',
  'aet.instructorCourse.courseForm.gradeSyncLinkLabel': 'Notensynchronisierung verwalten',
  'aet.instructorCourse.courseForm.courseNameLabel': 'Kursname',
  'aet.instructorCourse.courseForm.courseNamePlaceholder': 'Ohne Titel',
  'aet.instructorCourse.courseForm.sectionNameLabel': 'Name des Abschnitts',
  'aet.instructorCourse.courseForm.sectionNamePlaceholder': 'Ohne Titel',
  'aet.instructorCourse.courseForm.institutionFieldLabel': 'Institution',
  'aet.instructorCourse.courseForm.institutionSelectLabel': 'Select an Institution',
  'aet.instructorCourse.courseForm.institutionPlaceholder': 'Start typing your institution',
  'aet.instructorCourse.courseForm.institutionRequiredError': 'Institution ist erforderlich',
  'aet.instructorCourse.courseForm.institutionSearchError': 'Leider ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut.',
  'aet.instructorCourse.courseForm.institutionNoResults': 'Keine Ergebnisse gefunden',
  'aet.instructorCourse.courseForm.findAnotherInstitutionLabel': 'Find another institution',
  'aet.instructorCourse.courseForm.higherEducationSectionLabel': 'Higher Education:',
  'aet.instructorCourse.courseForm.k12InstitutionsSectionLabel': 'K12 Institutions:',
  'aet.instructorCourse.courseForm.k12InstitutionsDescription': 'Go to your My Courses dashboard to create courses for this type of institution',
  'aet.instructorCourse.courseForm.createK12CourseLabel': 'Create K-12 course',
  'aet.instructorCourse.courseForm.startDateLabel': 'Startdatum des Kurses',
  'aet.instructorCourse.courseForm.endDateLabel': 'Enddatum des Kurses',
  'aet.instructorCourse.courseForm.datePlaceholder': 'tt/mm/yy',
  'aet.instructorCourse.courseForm.allowCopyLabel': 'Erlauben Sie anderen, diesen Kurs zu kopieren',
  'aet.instructorCourse.courseForm.shareCodeLabel': 'Teilen Sie diesen Code mit den Ausbildern, die diesen Kurs kopieren möchten',
  'aet.instructorCourse.courseForm.copyCodeLabel': 'Code kopieren',
  'aet.instructorCourse.courseForm.optionalSuffix': '(optional)',
  'aet.instructorCourse.courseForm.formValidationLiveRegion': 'Das Formular hat Validierungsfehler',
  'aet.instructorCourse.courseForm.submitContinue': 'Weiter',
  'aet.instructorCourse.courseForm.submitContinueLoading': 'Wird gespeichert...',
  'aet.instructorCourse.courseForm.submitError': 'Wir konnten diesen Kurs nicht erstellen. Bitte versuchen Sie es erneut.',
  'aet.instructorCourse.courseForm.submitEditError': 'Wir konnten Ihre Änderungen nicht speichern. Bitte versuchen Sie es erneut.',
  'aet.instructorCourse.courseForm.submitSaveChanges': 'Änderungen speichern',
  'aet.instructorCourse.courseForm.materialsHeader': 'Kursmaterialien',
  'aet.instructorCourse.courseForm.resolveError': 'Wir konnten Ihre Kursmaterialien nicht laden. Bitte versuchen Sie es erneut.',
  'aet.instructorCourse.courseForm.copySourceError': 'We could not load the course to copy. Please search again from Create or copy course.',
  'aet.instructorCourse.coursesSort.lastViewed': 'Letztes Überprüfungsdatum',
  'aet.instructorCourse.coursesSort.recentlyAdded': 'Kürzlich hinzugefügt',
  'aet.instructorCourse.coursesSort.aToZ': 'A bis Z',
  'aet.instructorCourse.coursesSort.zToA': 'Z nach A',
  'aet.instructorCourse.manageRoster.column.name': 'Name',
  'aet.instructorCourse.manageRoster.column.role': 'Rolle',
  'aet.instructorCourse.manageRoster.column.email': 'E-Mail',
  'aet.instructorCourse.manageRoster.column.access': 'eTextbook Access',
  'aet.instructorCourse.manageRoster.column.status': 'Status',
  'aet.instructorCourse.manageRoster.column.statusInfoTooltip': 'Status information',
  'aet.instructorCourse.manageRoster.statusInfoModal.title': 'Status',
  'aet.instructorCourse.manageRoster.statusInfoModal.bodyParagraph1': 'This status reflects Pearson enrollment and may not match a student\'s enrollment status in your linked LMS course.',
  'aet.instructorCourse.manageRoster.statusInfoModal.bodyParagraph2': 'Students marked as Inactive will not have grades synced back to the LMS.',
  'aet.instructorCourse.manageRoster.access.tempAccessTitle': 'Temporary access',
  'aet.instructorCourse.manageRoster.access.active': 'Active eTextbook access',
  'aet.instructorCourse.manageRoster.access.endsOn': 'Ends: {date}',
  'aet.instructorCourse.manageRoster.access.ended': 'Ended:',
  'aet.instructorCourse.manageRoster.changeTo': 'Change to:',
  'aet.instructorCourse.manageRoster.notAvailable': '---',
  'aet.instructorCourse.roster.role.student': 'Student',
  'aet.instructorCourse.roster.role.ta': 'Lehrassistent(in)',
  'aet.instructorCourse.roster.role.instructor': 'Ausbilder(in)',
  'aet.instructorCourse.roster.status.active': 'Aktiv',
  'aet.instructorCourse.roster.status.inactive': 'Inaktiv',
  'aet.instructorCourse.manageRoster.filter.allMembers': 'Alle Mitglieder',
  'aet.instructorCourse.manageRoster.filter.activeStudents': 'Aktive Studierende',
  'aet.instructorCourse.manageRoster.filter.inactiveStudents': 'Inaktive Studierende',
  'aet.instructorCourse.manageRoster.filter.teachingAssistant': 'Lernassistent(in)',
  'aet.instructorCourse.manageRoster.filter.instructor': 'Ausbilder(in)',
  'aet.instructorCourse.courseForm.materialsAuthorLabel': 'Autor(in):',
  'aet.instructorCourse.courseForm.materialsIsbnLabel': 'ISBN:',
  'aet.instructorCourse.courseForm.materialsCreationDateLabel': 'Datum der Kurserstellung:',
  'aet.instructorCourse.noCoursesFound': 'Es wurden keine Kurse gefunden',
  'aet.instructorCourse.searchNoResultsTitle': 'No courses match “{searchTerm}”',
  'aet.instructorCourse.searchNoResultsDescription': 'Try a different course name.',
  'aet.instructorCourse.clearSearch': 'Clear search',
  'aet.instructorCourse.noCoursesEmptyStateTitle': 'Nothing here yet',
  'aet.instructorCourse.noCoursesEmptyStateDescription': 'Courses you create or are added to will appear here.',
  'aet.instructorCourse.backButton': 'Zurück',
  'aet.instructorCourse.selectCourse': 'Kurs auswählen',
  'aet.home.linkedToLms': 'Mit LMS verknüpft',
  'aet.instructorCourse.courseForm.title.create': 'Kurs erstellen',
  'aet.instructorCourse.courseForm.title.copy': 'Kurs kopieren',
  'aet.instructorCourse.courseForm.title.edit': 'Kursinformationen',
  'aet.instructorCourse.courseForm.copiedContentAccordion.settings.title': 'Einstellungen',
  'aet.studentRoster.manageStudentRosterButton': 'Liste der Studierenden verwalten',
  'aet.studentRoster.dontHaveAnyStudent': 'Looks like you don’t have any students.',
  'aet.studentRoster.lmsEmptyState.title': 'No students have accessed the course yet',
  'aet.studentRoster.lmsEmptyState.description': 'As soon as students click through from your LMS, you’ll see their names and progress here.',
  'aet.studentRoster.nonlmsEmptyState.description': 'As soon as students join your course, you’ll see their names and progress here.',
  'aet.syllabus.editContentDisabledTooltip': 'Cannot update assignment while student work is in progress.',
  'aet.assignments.exportStudentProgressButton': 'Fortschritte der Studierenden exportieren',
  'aet.home.student.roaster.enrolmentInformationTitle': 'Enrolment information',
  'aet.home.student.roaster.enrolmentInformation.status': 'Status:',
  'aet.home.student.roaster.enrolmentInformation.enrolled': 'Eingeschrieben:',
  'aet.home.student.roaster.enrolmentInformation.access': 'Access:',
  'aet.home.student.roaster.enrolmentInformation.role': 'Rolle:',
  'aet.home.student.roaster.enrolmentInformation.promotionCardTitle': '{studentName} hochstufen?',
  'aet.home.student.roaster.enrolmentInformation.promotionCardContent1': 'Als Lehrassistent(in) kann diese Person den Fortschritt und die Leistung aller Studierenden in dieser Klasse einsehen.',
  'aet.home.student.roaster.enrolmentInformation.promotionCardContent2': 'Diese Person kann außerdem Studierende und Aufgaben verwalten, jedoch die Klasse nicht löschen.',
  'aet.home.student.roaster.enrolmentInformation.promotionCardConfirmLabel': 'Zur Lernassistent(in) befördern',
  'aet.home.manageRoster.searchPlaceholder': 'Suche nach Studierendem',
  'aet.home.manageRoster.inactivateButtonLabel': 'Inaktive ausgewählte Studierende',
  'aet.home.manageRoster.FilterLabel': 'Show',
  'aet.home.manageRoster.updatingMessage': 'Teilnehmerliste wird aktualisiert... Dies kann einige Minuten dauern.',
  'aet.home.courses.search.searchPlaceHolder': 'Ihre Kurse suchen',
  'aet.courses.emptyStateDescription': 'Beginnen Sie damit, Ihren Kurs zu erstellen, indem Sie unten eine Option auswählen.',
  'nativePromoBanner.continueInBrowser': 'Im Browser fortsetzen',
  'globalnav.tooltip.hideNavText': 'Navigation ausblenden',
  'globalnav.tooltip.showNavText': 'Navigation anzeigen',
  'aet.syllabus.progressTitle': 'Extrahieren...',
  'aet.syllabus.progressDesc': 'Bitte warten Sie, während wir Ihren Lehrplan bearbeiten.',
  'aet.syllabus.uploadInputLabel': 'Ziehen Sie Dateien hierher und legen Sie sie ab oder klicken Sie zum Hochladen',
  'aet.syllabus.uploadSyllabusTabLabel': 'Lehrplan hochladen',
  'aet.syllabus.dateAdjusterTabLabel': 'Datumsanpassung',
  'aet.syllabus.addManuallyTabLabel': 'Aufgaben manuell hinzufügen',
  'aet.syllabus.addEditLaterText': 'Sie können später jederzeit Aufgaben hinzufügen und bearbeiten',
  'aet.syllabus.editAssignmentLabel': 'Aufgabe bearbeiten',
  'aet.syllabus.addAssignmentLabel': 'Aufgabe hinzufügen',
  'aet.syllabus.assignmentTitleLabel': 'Titel der Aufgabe',
  'aet.syllabus.assignmentTitleAutoPlaceholder': 'Automatically generated',
  'aet.syllabus.dueDateLabel': 'Fälligkeitsdatum',
  'aet.syllabus.editDueDateLabel': 'Fälligkeitsdatum bearbeiten',
  'aet.syllabus.chaptersCoveredLabel': 'Wählen Sie die zu behandelnden Kapitel oder Abschnitte aus.',
  'aet.syllabus.updateCtaLabel': 'Aufgabe aktualisieren',
  'aet.syllabus.addCtaLabel': 'Aufgabe hinzufügen',
  'aet.syllabus.uploadLabel': 'Hochladen',
  'aet.syllabus.confirmLabel': 'Bestätigen',
  'aet.syllabus.addContentLabel': 'Inhalt hinzufügen',
  'aet.syllabus.addEditContentLabel': 'Inhalt hinzufügen/bearbeiten',
  'aet.syllabus.notPublishedLabel': 'Nicht veröffentlicht',
  'aet.syllabus.updateDatesLabel': 'Datum aktualisieren',
  'aet.syllabus.dateNormalization.yearAdjustedContentSingle': 'Ihr Fälligkeitsdatum wurde aktualisiert. Überprüfen Sie es und veröffentlichen Sie es anschließend.',
  'aet.syllabus.coverageDedupe.adjustedContent': 'Ihre Kapitel- bzw. Abschnittsinformationen wurden aktualisiert. Bitte überprüfen Sie sie und veröffentlichen Sie sie anschließend.',
  'aet.syllabus.unassignedCoverageStatus': 'Einige Kapitel wurden noch nicht zugewiesen. Weisen Sie sie vor der Veröffentlichung zu.',
  'aet.syllabus.dateNormalization.manualEntryContent': 'Add a due date before you publish.',
  'aet.syllabus.pastDuePublishStatus': 'Update due date before you publish.',
  'aet.deleteAssignmentTitle': 'Aufgabe löschen?',
  'aet.deleteAssignmentTitleMultiple': 'Aufgaben löschen?',
  'aet.deleteAssignmentWarning': 'Diese Aktion kann nicht rückgängig gemacht werden, und alle zugehörigen Übermittlungen und Daten der Studierenden sind nicht mehr sichtbar.',
  'aet.deleteAssignmentKeepCTA': 'Aufgabe behalten',
  'aet.deleteAssignmentDeleteCTA': 'LÖSCHEN',
  'aet.assignments.loadingAsset': 'Inhalt wird geladen…',
  'aet.assignments.addToDate': 'Zum Datum hinzufügen',
  'aet.assignments.previewAsStudent': 'Vorschau als Studierende(r)',
  'aet.assignments.questionsAndTopics': 'Fragen und Themen',
  'aet.assignments.questionsAndTopicsModal.doneLabel': 'Fertig',
  'aet.assignments.questionsAndTopicsModal.dueDateLabel': 'Fälligkeitsdatum',
  'aet.assignments.questionsAndTopicsModal.questionsTotalLabel': 'Fragen insgesamt',
  'aet.assignments.questionsAndTopicsModal.questionOfTotalLabel': 'Frage {count} von {total}',
  'aet.assignments.questionsAndTopicsModal.sectionSelectLabel': 'Select a section',
  'aet.assignments.publishToStudents': 'Für Studierende veröffentlichen',
  'aet.assignments.availableToStudentsOn': 'Available to students on {0}',
  'aet.syllabus.addDateLabel': 'Datum hinzufügen',
  'aet.assistedSchedule.addToAssignmentModalTitle': 'Add to assignment',
  'aet.assistedSchedule.addToAssignmentModalEmptyLabel': 'No content yet',
  'aet.doneLabel': 'Fertig',
  'aet.assignments.dueDateLabel': 'Fälligkeitsdatum der Aufgabe',
  'aet.assignmentNameLabel': 'Assignment name',
  'aet.assignment.nameDisabledPlaceholder': 'Add content to generate a default name for your assignment',
  'aet.assignment.nameGeneratedPlaceholder': 'Automatically generated assignment name based on selected content',
  'aet.onboarding.getStarted.title': 'Get started creating assignments now:',
  'aet.onboarding.getStarted.manualSetup.title': 'Manuelle Einrichtung',
  'aet.onboarding.getStarted.manualSetup.description': 'Create and customize individual reading assignments and set their due dates',
  'aet.onboarding.getStarted.manualSetup.ctaLabel': 'Create manually',
  'aet.onboarding.getStarted.assistedScheduling.title': 'Weekly schedule',
  'aet.onboarding.getStarted.assistedScheduling.description': 'Pick a due day that repeats all term, then drag chapters into each week',
  'aet.onboarding.getStarted.assistedScheduling.ctaLabel': 'Build schedule',
  'aet.onboarding.getStarted.autoCreateAssignments.title': 'Auto-create assignments',
  'aet.onboarding.getStarted.autoCreateAssignments.description': 'Upload your syllabus to generate all reading assignments in seconds',
  'aet.onboarding.promotion.title': 'Turn assigned reading into active learning',
  'aet.onboarding.promotion.feature.1': 'Quickly create assignments with embedded questions, plus optional grade sync to your LMS',
  'aet.onboarding.promotion.feature.2': 'Nutzen Sie Echtzeit-Erkenntnisse, um Lernlücken zu erkennen und frühzeitig sicher und gezielt zu handeln.',
  'aet.onboarding.promotion.feature.3': 'Studierende erhalten mehr Unterstützung mit gezieltem Feedback und integrierter KI von Pearson',
  'aet.onboarding.getStarted.previewQuestions.prompt': 'Want to see what’s available?',
  'aet.onboarding.getStarted.previewQuestions.link': 'Preview all questions',
  'aet.questionPreview.title': 'Preview questions',
  'aet.questionPreview.chapterSelectLabel': 'Select chapter',
  'aet.questionPreview.questionLabel': 'question',
  'aet.questionPreview.questionsLabel': 'questions',
  'aet.questionPreview.correctAnswer': 'Correct answer',
  'aet.questionPreview.noQuestions': 'No questions are available for this chapter.',
  'aet.assistedSchedule.pageTitle': 'Weekly schedule',
  'aet.assistedSchedule.reviewPageTitle': 'Create your assignments',
  'aet.assistedSchedule.sectionTitle': 'Set up a weekly schedule',
  'aet.assistedSchedule.sectionDescription': 'Tip: Make assignments due 1 or 2 days before your class meets in order to get the most out of assignment insights',
  'aet.assistedSchedule.dueDaysLabel': 'Have assignments due every',
  'aet.assistedSchedule.dueDaysTip': 'Tip: Make assignments due 1 or 2 days before your class meets in order to get the most out of assignment insights',
  'aet.assistedSchedule.dueDaysPlaceholder': 'Choose one or more days of the week',
  'aet.assistedSchedule.dueDaysRequiredError': 'Select at least one day',
  'aet.assistedSchedule.viewQuestions': 'View questions',
  'aet.assistedSchedule.dueTimeRequiredError': 'Due time is required',
  'aet.assistedSchedule.timeZoneRequiredError': 'Time zone is required',
  'aet.assistedSchedule.startDateLabel': 'Start assignments by',
  'aet.assistedSchedule.endDateLabel': 'End assignments by',
  'aet.assistedSchedule.datePlaceholder': 'mm/dd/yyyy',
  'aet.assistedSchedule.startDateRequiredError': 'Start date is required',
  'aet.assistedSchedule.endDateRequiredError': 'End date is required',
  'aet.assistedSchedule.scheduleInstruction': 'Drag content into the assignment slots to build your schedule.',
  'aet.assistedSchedule.dragZoneLabel': 'Drag content here to assign it to students',
  'aet.assistedSchedule.clickToEditLabel': 'Click to edit',
  'aet.assistedSchedule.clearDataLabel': 'Clear data',
  'aet.assistedSchedule.formValidationLiveRegion': 'Form has validation errors',
  'aet.assistedSchedule.noQuestionsError': 'Each assignment must include content with at least one question.',
  'aet.assistedSchedule.noQuestionsWarningLabel': 'Add content with at least 1 question to save this assignment.',
  'aet.assistedSchedule.autoNameAssignmentsLabel': 'Automatically name assignments based on content',
  'aet.assistedSchedule.autoNameAssignmentsInstruction': 'Assignment names will be generated from the content.',
  'aet.assistedSchedule.noAssignmentsModalTitle': 'No assignments can be created',
  'aet.assistedSchedule.noAssignmentsModalMessage': 'The selected date range is too short to generate any assignments. Extend the date range and try again.',
  'aet.assistedSchedule.addNewLabel': 'Add new',
  'aet.assistedSchedule.addToNewAssignmentLabel': 'Add to new assignment',
  'aet.assistedSchedule.saveAsDraftLabel': 'Save as draft',
  'aet.assistedSchedule.saveAndPublishLabel': 'Save and publish',
  'aet.assignments.allCaughtUpDescription': 'Diese Woche sind keine Aufgaben fällig.',
  'aet.assignments.progressTitle': 'Fortschritt',
  'aet.assignments.performanceTitle': 'Sicherheit',
  'aet.assignments.completionTitle': 'Abschluss',
  'aet.assignments.statusTitle': 'Status',
  'aet.assignments.addTooltip': 'Aufgabe hinzufügen',
  'aet.assignments.deleteTooltip': 'Ausgewählte Aufgaben löschen',
  'aet.assignments.selectToDeleteLabel': 'Auswahl- und Löschmodus',
  'aet.assignments.bulkEditTooltip': 'Bearbeiten von mehreren Aufgaben gleichzeitig',
  'aet.assignments.title': 'Aufgaben',
  'aet.assignments.assignmentTitle': 'Aufgabe',
  'aet.assignments.dueDate': 'Fälligkeitsdatum',
  'aet.tabular.searchPlaceholder.assignments': 'Aufgaben suchen',
  'aet.tabular.searchPlaceholder.students': 'Studierende suchen',
  'aet.tabular.searchPlaceholder.questions': 'Fragen suchen',
  'aet.assignemnts.columnDueDateInfoTooltip': 'Einer oder mehr Studierende haben eine Verlängerung des Fälligkeitsdatums für alle Aufgaben erhalten',
  'aet.assignemnts.singleDueDateInfoTooltip': 'Einer oder mehr Studierende haben eine Verlängerung des Fälligkeitsdatums für diese Aufgabe erhalten',
  'aet.assignemnts.masterDueDateInfoTooltip': 'Einer oder mehr Studierende haben eine Verlängerung des Fälligkeitsdatums für alle Aufgaben erhalten. Sehen Sie nach Info-Symbolen, um diese Aufgaben zu ermitteln.',
  'aet.home.loading': 'Wird geladen...',
  'aet.home.errorFetchingAssignments': 'Fehler beim Abrufen der Aufgaben',
  'aet.home.dueThisWeekTitle': 'Diese Woche fällig',
  'aet.home.allCaughtUpTitle': 'Sie haben alles aufgeholt!',
  'aet.home.allCaughtUpDescription': 'Diese Woche sind keine Aufgaben fällig.',
  'aet.home.suggestedRemediationTitle': 'Empfohlene Überprüfung durch die Lernvorbereitung',
  'aet.home.noSuggestedRemediationTitle': 'Kein empfohlenes Überprüfungsmaterial',
  'aet.home.noSuggestedRemediationDescription': 'Kehren Sie nach Ihrer nächsten Aufgabe wieder zurück.',
  'aet.home.assignmentIncludesTitle': 'Aufgabe umfasst',
  'aet.home.sectionsLabel': 'Kapitel',
  'aet.home.questionsCount': '{count} Fragen',
  'aet.home.dueLabel': 'Fällig: {dueDate}',
  'aet.home.due': 'Fällig:',
  'aet.home.progressCompletedLabel': 'Abgeschlossen',
  'aet.home.progressCompletedPastDueLabel': 'Nach Fälligkeit abgeschlossen',
  'aet.home.progressInProgressLabel': 'In Arbeit',
  'aet.home.progressPartiallyCompleteLabel': 'Partially complete',
  'aet.home.progressNotStartedLabel': 'Nicht gestartet',
  'aet.home.progressCountOfTotal': '{count} von {total}',
  'aet.home.NotAttemptedLabel': 'Kein Versuch unternommen',
  'aet.home.questionsTotalLabel': 'Fragen insgesamt',
  'aet.home.progressCompletedOnTimeLabel': 'Pünktlich fertiggestellt',
  'aet.home.segmentGreatLabel': 'Super',
  'aet.home.segmentGettingThereLabel': 'OK',
  'aet.home.segmentNeedsReviewLabel': 'Muss bearbeitet werden',
  'aet.home.segmentOkayLabel': 'OK',
  'aet.home.editAssignmentTooltip': 'Aufgabe bearbeiten',
  'aet.home.deleteAssignmentTooltip': 'Aufgabe löschen',
  'aet.home.viewDetailsButton': 'Einzelheiten anzeigen',
  'aet.home.viewAsStudentButton': 'Ansicht als Studierende(r)',
  'aet.home.welcomeButtonText': 'Beginnen Sie →',
  'aet.review.emptyStateTitle': 'Nichts zu überprüfen',
  'aet.review.emptyStateDescription': 'Kehren Sie nach Ihrer nächsten Aufgabe wieder zurück.',
  'aet.dashboard.tabs.upNext': 'Nächster Punkt',
  'aet.dashboard.tabs.welcome': 'Herzlich willkommen',
  'aet.dashboard.tabs.assignments': 'Aufgaben',
  'aet.dashboard.tabs.review': 'Überprüfen',
  'aet.dashboard.tabs.studentRoster': 'Studierende',
  'aet.dashboard.classSchedule': 'Stundenplan:',
  'aet.syllabus.dueTimeLabel': 'Fälligkeitsdatum',
  'hero.accessEducatorGuides': 'Zugriff auf Leitfäden für Pädagogen',
  'aet.assignment.save': 'Speichern',
  'aet.assignment.finish': 'Beenden',
  'aet.assignment.saveAndAdd': 'Speichern und weitere hinzufügen',
  'aet.assignment.delete': 'LÖSCHEN',
  'aet.assignment.saveAndClose': 'Speichern und schließen',
  'aet.studentRoster.title': 'Studierende',
  'aet.studentRoster.titlev1': 'Student',
  'aet.studentRoster.dueDatesAdjustmentLabel': 'Fälligkeitsdatum',
  'aet.studentRoster.dueDateAdjustment.option.0': 'Standard',
  'aet.studentRoster.dueDateAdjustment.option.2': '+2 Tage',
  'aet.studentRoster.dueDateAdjustment.option.3': '+3 Tage',
  'aet.studentRoster.dueDateAdjustment.option.5': '+5 Tage',
  'aet.studentRoster.dueDateAdjustment.option.week.1': '+1 Woche',
  'aet.studentRoster.dueDateAdjustment.option.week.2': '+2 Woche',
  'aet.studentRoster.dueDateAdjustment.option.lastDayOfClass': 'Letzer Tag des Kurses',
  'aet.studentRoster.dueDateAdjustment.toast.partial.title.multiple': '{count} of {total} assignments updated',
  'aet.studentRoster.dueDateAdjustment.toast.partial.message': '{skippedCount} assignments are past due. Edit manually to set new due dates.',
  'aet.studentRoster.dueDateAdjustment.toast.allPastDue.title': 'No assignments updated',
  'aet.studentRoster.dueDateAdjustment.toast.allPastDue.message': 'All assignments are past due. Edit manually to set new due dates.',
  'aet.studentRoster.dueDateAdjustment.toast.success.title.multiple': '{count} assignments updated',
  'aet.studentRoster.dueDateAdjustment.toast.success.message.single': 'New due dates have been added to <b>{assignmentTitle}</b>.',
  'aet.studentRoster.dueDateAdjustment.toast.success.message.multiple': 'New due dates have been added to multiple assignments.',
  'aet.bulkEdit.bulkSplitInstruction': 'Wir teilen Ihre Aufgaben gleichmäßig auf.',
  'aet.bulkEdit.Description': 'Figma ipsum component variant main layer. Editor library device auto star reesizing pencil horizontal. Polygon main list figjam star layout object connection hand scale.',
  'aet.bulkEdit.firstAssignmentDue': 'Erste Aufgabe fällig',
  'aet.bulkEdit.lastAssignmentDue': 'Letzte Aufgabe fällig',
  'aet.bulkEdit.assignmentsDueDays': 'An welchen Tagen sollen die Aufgaben fällig sein?',
  'aet.bulkEdit.addEditLaterText': 'Wir verwenden KI, um Aufgaben zu erstellen, die Sie später jederzeit hinzufügen und bearbeiten können.',
  'aet.bulkEdit.monday': 'Montag',
  'aet.bulkEdit.tuesday': 'Dienstag',
  'aet.bulkEdit.wednesday': 'Mittwoch',
  'aet.bulkEdit.thursday': 'Donnerstag',
  'aet.bulkEdit.friday': 'Freitag',
  'aet.bulkEdit.saturday': 'Samstag',
  'aet.bulkEdit.sunday': 'Sonntag',
  'aet.toast.assignmentCreated.title': '1 assignment created',
  'aet.toast.assignmentCreated.title.multiple': '{count} assignments created',
  'aet.toast.assignmentCreated.single': 'Assignment was named <b>{assignmentTitle}</b>.',
  'aet.toast.assignmentCreated.multiple': 'Assignment names were also added.',
  'aet.toast.assignmentUpdated.title': 'Erfolgreich aktualisiert.',
  'aet.toast.assignmentUpdated.title.single': '1 assignment updated',
  'aet.toast.assignmentUpdated.single': 'Your changes have been saved to <b>{assignmentTitle}</b>.',
  'aet.toast.assignmentUpdated.multiple': '{count} Aufgaben wurden aktualisiert',
  'aet.toast.assignmentPublished.single': '{count} assignment published',
  'aet.toast.assignmentPublished.multiple': '{count} assignments published',
  'aet.toast.assignmentPublished.subtitle': 'Der Inhalt der Aufgabe kann solange bearbeitet werden, bis die Studierenden Ihre Arbeit beginnen.',
  'aet.toast.assistedScheduleCreated.single': '{count} Assignment created!',
  'aet.toast.assistedScheduleCreated.multiple': '{count} Assignments created!',
  'aet.toast.assistedScheduleCreated.subtitle': 'Default assignment titles were updated based on content.',
  'aet.toast.assistedSchedulePublished.single': '{count} Assignment published!',
  'aet.toast.assistedSchedulePublished.multiple': '{count} Assignments published!',
  'aet.toast.viewAssignment': 'Aufgabe anzeigen',
  'aet.toast.viewAssignments': 'Aufgaben anzeigen',
  'aet.welcome.title': 'Ihr Pearson eTextbook ist jetzt mit Ihrem LMS-Kurs verknüpft',
  'aet.welcome.LMSAccounTitle': 'Fortschritte einsehen',
  'aet.welcome.LMSAccounDescription': 'Sehen Sie auf einen Blick, mit welchen Themen Ihre Klasse Schwierigkeiten hat.',
  'aet.welcome.createAssignmentsTitle': 'Aufgaben erstellen',
  'aet.welcome.createAssignmentsDescription': 'Kapitel manuell oder durch Hochladen Ihres Lehrplans zuweisen.',
  'aet.welcome.progressViewTitle': 'Verfolgen Sie die Leistung in Ihrem LMS',
  'aet.welcome.progressViewDescription': 'Wählen Sie die Einstellungen für die Notensynchronisation in Ihrem LMS-Kurs.',
  'aet.assignmentDetails.noAssignmentFound': 'Keine Aufgabe gefunden',
  'aet.assignments.loadingErrorTitle': 'Aufgabe kann im Moment nicht geladen werden',
  'aet.assignments.loadingErrorDescription': 'Versuchen Sie, die Seite zu aktualisieren oder kehren Sie später wieder zurück.',
  'aet.assignmentStudentDetails.noDataFound': 'Noch keine Daten',
  'aet.assignmentStudentDetails.noData': 'No data',
  'aet.studentRoster.noStudentsRegisteredYet': 'Keine Studierenden angemeldet',
  'aet.studentRoster.noStudentsRegisteredYetDescription': 'Die Studierenden treten Ihrem Kurs bei, sobald sie das eTextbook kaufen.',
  'aet.home.editAssignmentTooltipDisabled': 'Kann nicht bearbeitet werden: Arbeiten der Studierenden sind noch in Bearbeitung',
  'aet.home.deleteAssignmentTooltipDisabled': 'Kann nicht gelöscht werden: Arbeiten der Studierenden sind noch in Bearbeitung',
  'aet.home.StudentDetails.questions': 'Fragen',
  'aet.home.StudentDetails.attempts': 'Versuche',
  'aet.home.StudentDetails.comprehension': 'Sicherheit',
  'hero.titleInfo.tooltip': 'Titel-Informationen',
  'aet.home.publishAssignments': 'Alle Aufgaben veröffentlichen',
  'aet.assignments.saveScheduleAsDraft': 'Plan als Entwurf speichern',
  'aet.assignments.reviewBeforePublishAlert': 'Überprüfen Sie Ihre Aufgaben und veröffentlichen Sie sie anschließend, damit sie für die Studierenden sichtbar werden.',
  'aet.assignments.copiedCoursePublishAlert': 'Fügen Sie Ihren kopierten Aufgaben Termine hinzu und veröffentlichen Sie sie, damit sie für die Studierenden sichtbar sind.',
  'aet.assignments.allSetPublishAlert': 'Alles bereit? Veröffentlichen Sie Ihre Aufgaben, damit sie für die Studierenden sichtbar werden.',
  'aet.assignments.emptyStateTitle': 'No assignments yet',
  'aet.assignments.emptyStateDescription': 'Assignments you create will appear here',
  'aet.dashboard.footer': 'Einige mit KI erstellte Inhalte basieren auf Lernmaterialien von Pearson. Pearson verfügt zwar über ein Verfahren zur Validierung der Ergebnisse, aber generative KI kann dennoch ungenaue Informationen über Personen, Orte oder Fakten geben.',
  'aet.home.bulkEditTitle': 'Mehrere Aufgaben gleichzeitig bearbeiten',
  'aet.home.bulkEditSubtitle': 'Nehmen Sie Ihre Änderungen an Ihrem Lehrplan vor und laden Sie ihn dann hier wieder hoch. Ihre Aufgaben und Fälligkeitstermine werden dann entsprechend aktualisiert.',
  'aet.home.createAssignmentTitle': 'Aufgaben erstellen',
  'aet.assignments.includedInAnotherAssignmentTooltip': 'In einer anderen Aufgabe enthalten',
  'aet.assignments.someSectionsIncludedInAnotherAssignmentTooltip': 'Einige Abschnitte sind in einer anderen Aufgabe enthalten',
  'aet.welcome.welcome.Title': 'Herzlich willkommen!',
  'aet.home.student.roaster.ProgressTitle': 'Insgesamt abgeschlossen',
  'aet.assignmentStudentDetails.startAssignmentDescription': 'Kehren Sie zurück, sobald die Studierenden die Aufgabe beginnen.',
  'aet.home.whatDueThisWeekTitle': 'Diese Woche sind folgende Aufgaben fällig',
  'aet.assignments.edit.errorTitle': '{count} Aufgaben enthalten Fehler',
  'aet.assignments.edit.errorSubTitle': 'Aufgaben mit Fehlern können nicht veröffentlicht werden. Bearbeiten Sie sie oder veröffentlichen Sie ohne diese Aufgaben',
  'aet.assignments.edit.publishAnyway': 'Trotzdem veröffentlichen',
  'aet.assignments.edit.editAssignments': 'Aufgaben bearbeiten',
  'aet.assignments.edit.validationInfoToolTip': 'Aufgabe bearbeiten, um Fehler zu beheben',
  'aet.assignments.error.assignmentCreated.title': 'Alle Aufgaben sind fehlerhaft',
  'aet.assignments.error.assignmentCreated.description': 'Aufgaben mit Fehlern können nicht veröffentlicht werden. Bearbeiten Sie sie, oder versuchen Sie es mit einem anderen Lehrplan.',
  'aet.assignments.error.uploadSyllabus': 'Lehrplan hochladen',
  'aet.assignments.error.editAssignments': 'Aufgaben bearbeiten',
  'aet.mondly.title': 'Sprachen',
  'aet.studentRoster.errorState.title': 'Liste der Studierenden nicht verfügbar',
  'aet.studentRoster.errorState.description': 'Wir konnten Ihre Liste der Studierenden nicht laden. Versuchen Sie, die Liste zu aktualisieren oder versuchen Sie es später erneut.',
  'aet.assignments.sectionLabel': 'Abschnitt(e)',
  'aet.assignments.sectionLabelCapitalized': 'Section(s):',
  'aet.assignments.sectionsPrefix': 'Sections:',
  'aet.assignments.tags.dueNext': 'Due next',
  'aet.assignments.tags.pastDue': 'Past due',
  'aet.assignments.completionLabel': 'answered',
  'aet.assignments.chaptersPrefix': 'Chapters:',
  'aet.assignments.questionsLabel': 'Frage(n)',
  'aet.assignments.assignmentsLabel': 'Aufgabe(n)',
  'aet.assignments.performanceProgressBar': 'Leistungsfortschrittsbalken',
  'aet.assignments.completionProgressBar': 'Abschlussfortschrittsbalken',
  'aet.syllabus.deleteConfirmationSubtitleSingle': 'Sind Sie sicher, dass Sie diese Aufgabe löschen möchten?',
  'aet.syllabus.deleteConfirmationSubtitleBulk': 'Sind Sie sicher, dass Sie diese Aufgaben löschen möchten?',
  'aet.home.nextAssignmentTitle': 'Nächste Aufgabe',
  'aet.home.courseSettings': 'Kurseinstellungen',
  'aet.home.assignmentSettings': 'Assignment settings',
  'aet.home.pearsonETextbookResources': 'Pearson+ eTextbook-Ressourcen',
  'aet.home.etextbookInformation': 'eTexbook-Informationen',
  'aet.multiple.deleteAssignmentKeepCTA': 'Aufgabe(en) behalten',
  'aet.syllabus.processingText.header': 'Wir organisieren die Ihrer Klasse zugewiesene Lektüre - dies dauert nur einen Moment.',
  'aet.syllabus.processingText.uploading': 'Ihr Dokument wird hochgeladen',
  'aet.syllabus.processingText.activating': 'Aktivieren von KI-Komponenten',
  'aet.syllabus.processingText.extracting': 'Die Leseaufgaben werden extrahiert',
  'aet.syllabus.processingText.mapping': 'Die Textbuchinhalte werden zugeordnet',
  'aet.syllabus.processingText.finishing': 'Fertigstellung',
  'aet.syllabus.uploadErrorMessage': 'Vergewissern Sie sich, dass Ihre PDF- oder .docx-Datei weniger als 10 MB groß und Ihre Internetverbindung stabil ist.',
  'aet.syllabus.uploadNoAssignmentsMessage': 'Es wurden keine Leseaufgaben gefunden',
  'aet.syllabus.uploadNoAssignmentsDescription': 'Die Leseaufgaben konnten aus dieser Datei nicht übernommen werden. Sie können sie manuell hinzufügen.',
  'aet.syllabus.uploadFailedRetryCTA': 'Erneut versuchen',
  'aet.syllabus.uploadModal.noAssignments.title': 'Couldn\'t find assignments',
  'aet.syllabus.uploadModal.noAssignments.body1': 'We weren\'t able to find any reading assignments within the uploaded syllabus.',
  'aet.syllabus.uploadModal.noAssignments.body2': 'Prüfen Sie noch einmal, ob Ihr Lehrplan <qualities a syllabus should have for this to work> hat und versuchen Sie es erneut oder gehen Sie zur manuellen Aufgabenerstellung über.',
  'aet.syllabus.uploadModal.noAssignments.manualCreationCTA': 'Manuelle Erstellung',
  'aet.syllabus.uploadModal.noAssignments.backToUploadCTA': 'Back to upload',
  'aet.syllabus.uploadModal.genericFailure.title': 'Leider ist ein Fehler aufgetreten',
  'aet.syllabus.uploadModal.genericFailure.body1': 'Wir konnten den Lehrplan nicht hochladen und verarbeiten.',
  'aet.syllabus.uploadModal.genericFailure.body2': 'Prüfen Sie Ihre Internetverbindung, und versuchen Sie es erneut oder gehen Sie zur manuellen Aufgabenerstellung über.',
  'aet.syllabus.uploadModal.successTotal.title': 'Bereit zur Überprüfung',
  'aet.syllabus.uploadModal.successTotal.body1': 'We found {count} assignments from your syllabus.',
  'aet.syllabus.uploadModal.successTotal.body2': 'Make any adjustments, then save or publish when you\'re ready. You can continue making changes before students start working.',
  'aet.syllabus.uploadModal.successPartial.title': 'Bereit zur Überprüfung',
  'aet.syllabus.uploadModal.successPartial.body1': 'We found {count} assignments from your syllabus.',
  'aet.syllabus.uploadModal.successPartial.body2': 'We couldn\'t find exact matches in the eTextbook for every item. Review your assignments to make any adjustments, then save or publish when you\'re ready.',
  'aet.syllabus.uploadModal.reviewAssignmentsCTA': 'Aufgaben überprüfen',
  'aet.syllabus.selectChapterWithQuestions': 'Wählen Sie ein Kapitel mit einer Frage/Frage(n).',
  'preferenceSetting.subTitle': 'Diese Einstellungen sind die Standardeinstellungen für alle Teilnehmer dieses Kurses.',
  'preferenceSetting.sections.isAIStudyEnabled.label': 'KI-Interaktionen',
  'preferenceSetting.sections.isAIStudyEnabled.subLabel': 'KI-Lernwerkzeug und KI-Zusammenfassungen in den Suchergebnissen aktivieren',
  'preferenceSetting.sections.isStudyPrepEnabled.subLabel': 'Lernvorbereitungsressourcen zu diesem Buch anzeigen',
  'aet.syllabus.footer': 'Die Erstellung von Aufgaben wird von KI nicht unterstützt',
  'aet.dashboard.footerDialogDeatils': 'Generative KI wird eingesetzt, um Aufgabenstellungen auf der Grundlage von Pearson-Lernmaterialien zu erstellen. Obwohl Pearson über einen Prozess zur Validierung der Ergebnisse verfügt, kann es dennoch vorkommen, dass die generative KI ungenaue Informationen über Personen, Orte oder Sachverhalte liefert. KI wird außerdem verwendet, um Inhalte auf der Grundlage des von Ihnen bereitgestellten Lehrplans und/oder Zeitplans zu Aufgaben zusammenzufassen.',
  'aet.review.footer': 'Erstellt unter Verwendung von KI',
  'aet.footerCard.dismiss': 'Ablehnen',
  'preferenceSetting.sections.isStudyPrepEnabled.descriptionText1': 'Die Lernvorbereitung ist ein zusätzliches tool, die das Lernen unterstützt, indem sie den Studierenden Videos und Übungsaufgaben zur Verfügung stellt, die auf diesen Kurs zugeschnitten sind.',
  'preferenceSetting.sections.isStudyPrepEnabled.descriptionText2': 'Studierende, deren Zugangsplan keine Lernvorbereitung beinhaltet, werden möglicherweise aufgefordert, ein Abonnement abzuschließen, um die Ressourcen zur Lernvorbereitung weiterhin nutzen zu können.',
  'preferenceSetting.sections.isStudyPrepEnabled.descriptionText3': 'Studierende, die die Lernvorbereitung bereits gekauft haben, sind von dieser Regelung nicht betroffen.',
  'preferenceSetting.sections.isStudyPrepEnabled.helpLinkText': 'Erfahren Sie mehr über die Vorteile der Lernvorbereitung',
  'aet.home.viewCourseId': 'Kurs-ID anzeigen',
  'aet.home.copy': 'Kopieren',
  'aet.home.copied': 'Kopiert',
  'aet.home.courseLabel': 'Kurs-ID:',
  'schoolInfoCard.addUniversity': 'Schule hinzufügen',
  'schoolInfoCard.title': 'Schulinformationen',
  'schoolInfoCard.titleV1': 'Erzählen Sie uns von Ihrem Kurs',
  'schoolInfoCard.cta': 'Beginnen Sie',
  'schoolInfoCard.pickInstitution': 'Schule auswählen',
  'schoolInfoCard.addUniversityTitle': 'Fügen Sie Ihre Schule hinzu',
  'schoolInfoCard.addUniversitySubtitle': 'Da wir Ihre Schule und Ihren Kurs kennen, können wir Ihnen die besten Lernmaterialien empfehlen.',
  'schoolInfoCard.searchPlaceholder': 'Suchen Sie nach Ihrer Schule…',
  'schoolInfoCard.skip': 'Diesen Schritt überspringen',
  'schoolInfoCard.nextStep': 'Nächster Schritt',
  'schoolInfoCard.notInList': 'Meine Schule ist nicht auf der Liste',
  'schoolInfoCard.noResults': 'Keine Schulen gefunden, die Ihrer Suche entsprechen',
  'schoolInfoCard.noResultsHeading': 'Sie können Ihre Schule nicht finden?',
  'schoolInfoCard.noResultsInstruction': 'Geben Sie unten den vollständigen Namen ein',
  'schoolInfoCard.noResultsInputPlaceholder': 'Name der Schule',
  'schoolInfoCard.addInstitutionLabel': 'Diese Schule hinzufügen',
  'aet.assignments.assignmentTitlePlaceholder': 'Einen Titel eingeben',
  'aet.assignments.titleValidation.titleRequired': 'Titel der Aufgabe ist erforderlich.',
  'aet.assignments.titleValidation.titleTooLong': 'Titel der Aufgabe darf {0} Zeichen nicht überschreiten.',
  'aet.assignments.titleValidation.titleInvalidChar': 'Titel der Aufgabe enthält nicht unterstützte Zeichen.',
  'aet.assignments.titleValidation.titleDuplicate': 'Titel der Aufgabe existiert bereits',
  'aet.syllabus.timeZoneLabel': 'Zeitzone',
  'aet.review.reviewReadingFromAssignments': 'Lektüre der Aufgabe wiederholen',
  'aet.assignments.chaptersLabel': 'Kapitel',
  'menu.myAccount.subTitle': 'Ihre Institution ist hier zu finden',
  'menu.myAccount.subTitleNotAvailable': 'Sie können die Institution jederzeit hier hinzufügen.',
  'schoolInfoCard.toastMessage': 'Universität wurde gespeichert',
  'aet.review.threeDotMenu.askAI': 'KI fragen',
  'aet.home.suggestedRemediationSubtitle': 'Sehen Sie sich relevante Videos an und üben Sie, um die Themen Ihres Kurses sicher zu beherrschen.',
  'aet.home.laggedQuestionLabel': 'Markierte Fragen',
  'aet.home.correctAnswer': 'Richtige Antwort',
  'aet.home.incorrectAnswer': 'Häufigste falsche Antwort',
  'aet.home.behaviourTrendsLabel': 'Ergebnisse der Fragen',
  'aet.home.strugglingStudentsLabel': 'Studierende mit Lernschwierigkeiten',
  'aet.home.patternsInStudensAiLabel': 'Muster der KI-Nutzung durch Studierende',
  'aet.home.questionLabel': 'Frage',
  'aet.home.studentAskingSimilarQuestions': 'Studierende stellen ähnliche Fragen',
  'aet.home.assignmentDifficultQuestions': 'Schwierige Fragen',
  'aet.home.behaviorTrends': 'Ergebnisse der Fragen',
  'aet.home.behaviors': 'Leistungsanzeigen',
  'aet.home.mostDifficultTopics': 'Schwierigste Fragen',
  'aet.home.commentsFromStudentLabel': 'Kommentare von Studierenden',
  'aet.home.disregard': 'Ignorieren',
  'aet.home.reportAsInaccurate': 'Als ungenau melden',
  'aet.home.Flagged': 'Markiert',
  'aet.home.reportQuestionTitle': 'Frage melden',
  'aet.home.reportQuestionLabel': 'Was war an dieser Frage falsch?',
  'aet.home.showComments': 'Anmerkungen anzeigen',
  'aet.home.studentReports': 'Berichte der Studierenden',
  'aet.home.placeholderText': 'Bitte erläutern Sie…',
  'aet.home.reportQuestion.notRelevant': 'Nicht relevant',
  'aet.home.reportQuestion.notCorrect': 'Nicht korrekt',
  'aet.home.reportQuestion.unsafe': 'Unsicher/schädlich',
  'aet.home.reportQuestion.somethingElse': 'Etwas anderes',
  'aet.home.StudentDetails.assistedByAI': 'Unterstützt von AI',
  'aet.home.strugglingStudents.emptyStateTitle': 'Keine Studierenden haben im Moment Lernschwierigkeiten',
  'aet.home.strugglingStudents.emptyStateDescription': 'Versuchen Sie es später erneut.',
  'aet.home.overallStatus.excelling': 'Hervorragend',
  'aet.home.overallStatus.fallingBehind': 'Im Rückstand',
  'aet.home.overallStatus.keepingUp': 'Im Durchschnitt',
  'aet.home.showOnlyDifficultQuestionsLabel': 'Nur „Schwierige Fragen“ anzeigen',
  'aet.home.showOnlyStrugglingStudentsLabel': 'Nur „Studierende mit Lernschwierigkeiten“ anzeigen',
  'aet.home.viewQuestionInAssignment': 'Frage der Aufgabe anzeigen',
  'aet.home.insightRisk.incorrectFirstAttempts': 'Falsche erste Versuche',
  'aet.home.insightRisk.multipleIncorrectAttempts': 'Mehrere Fehlversuche',
  'aet.home.insightRisk.lowConfidence': 'Geringe Sicherheit',
  'aet.home.insightRisk.mediumConfidence': 'Mittlere Sicherheit',
  'aet.home.insightRisk.lowEngagement': 'Geringes Engagement',
  'aet.home.insightRisk.countOfStudents': '{count} von {total} Studierenden',
  'aet.home.insightRisk.na': 'Nicht zutreffend',
  'aet.home.strugglingStudentsHereLabel': 'Studierende, die hierbei Lernschwierigkeiten haben',
  'aet.home.insightRisk.didNotAttempt': 'Haben keinen Versuch unternommen',
  'aet.home.insightRisk.attempted': 'Attempted',
  'aet.courseHeader.assignableEText': 'Assignable eText',
  'aet.courseHeader.lmsIntegration': 'LMS-Integration',
  'aet.courseHeader.lmsIntegrationSubLabel': 'Connected to your LMS',
  'aet.instructorCourse.courseForm.institutionNotOfferedError': 'This institution does not offer this product.',
  'aet.unlinkCourse.title': 'Unlink Pearson and [LMS] courses?',
  'aet.unlinkCourse.warning.accessInfoBeforePearson': 'Your Pearson course will be unlinked from your [LMS] course. You can still access the Pearson course by signing into ',
  'aet.unlinkCourse.warning.pearsonLinkLabel': 'Pearson',
  'aet.unlinkCourse.warning.accessInfoAfterPearson': ' with your linked account.',
  'aet.unlinkCourse.warning.relinkInfo': 'If no students are enrolled in the Pearson course you’re unlinking, you can link it again with the same [LMS] course.',
  'aet.unlinkCourse.beforeContinueHeading': 'Before you continue:',
  'aet.unlinkCourse.beforeContinueItem': 'If you link your [LMS] course with a different Pearson course, delete all Pearson grades from your [LMS] gradebook and any areas or modules in your LMS course. Otherwise, your [LMS] course may have duplicate grades.',
  'aet.unlinkCourse.inProgressCta': 'Unlinking...',
  'aet.unlinkCourse.okCta': 'OK',
  'aet.unlinkCourse.success.title': 'Unlink successful',
  'aet.unlinkCourse.success.heading': 'Your course has been unlinked from your LMS',
  'aet.unlinkCourse.success.descriptionBeforePearson': 'You can still access the course by signing into ',
  'aet.unlinkCourse.success.descriptionAfterPearson': ' with your Pearson account.',
  'aet.unlinkCourse.failure.title': 'Couldn\'t unlink course',
  'aet.unlinkCourse.failure.paragraph1': 'Your course couldn\'t be unlinked from your LMS. Wait a few minutes and try again.',
  'aet.unlinkCourse.failure.paragraph2': 'If the problem continues, contact Pearson Support.'
};

export default de;
